import { Grid } from '@material-ui/core';
import { EntityAboutCard, EntityHasSubdomainsCard, EntityLayout } from '@backstage/plugin-catalog';
import { EntityRelationsGraph } from '@backstage/plugin-catalog-graph';
import { useEntity } from '@backstage/plugin-catalog-react';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';

import { EntityWarningContent } from './modules/EntityWarningContent';
import { SystemsTable } from './modules/SystemsTable';
import { DomainExtensionCard } from './cards/ExtensionCards';
import { DebugTab } from './tabs/DebugTab';

function Overview() {
    return (
        <Grid container spacing={3} alignItems="stretch">
            <EntityWarningContent />
            <Grid item md={6}>
                <EntityAboutCard />
            </Grid>
            <Grid item md={6}>
                <DomainExtensionCard />
            </Grid>
            <Grid item md={6}>
                <EntityHasSubdomainsCard title='Subdomains' />
            </Grid>
            <Grid item md={6}>
                <SystemsTable />
            </Grid>
            <Grid item md={12}>
                <EntityCatalogGraphCard />
            </Grid>


        </Grid>
    );
}

function Diagram() {
    const { entity } = useEntity();
    return (
        <Grid container spacing={3} alignItems="stretch">
            <Grid item md={12}>
                <EntityRelationsGraph rootEntityNames={{ kind: entity.kind || '', namespace: entity.metadata.namespace || '', name: entity.metadata.name || '' }} maxDepth={2} />
            </Grid>
        </Grid>
    );
}


export const domainPage = (
    <EntityLayout>
        <EntityLayout.Route path="/" title="Overview">
            <Overview />
        </EntityLayout.Route>

        <EntityLayout.Route path="/diagram" title="Diagram">
            <Diagram />
        </EntityLayout.Route>

        <EntityLayout.Route path="/debug" title="Debug">
            <DebugTab />
        </EntityLayout.Route>

    </EntityLayout>
);

